import React, { FC } from 'react'
import cn from 'classnames'
import { User } from '@components/icons'
import { useAuthUI } from '@corratech/pylot-auth-manager'
import { Button } from '@corratech/pylot-ui'
import DropdownMenu from './../DropdownMenu/DropdownMenu'
import AddToCartIcon from './../AddToCartIcon/AddToCartIcon'
import { useTranslation } from 'react-i18next'
import s from '@corratech/air-ooka-header/UserNav/UserNav.module.scss'
import StoreSwitcher from './../StoreSwitcher/StoreSwitcher'
import { useLogout } from '@components/alfakher/pylot-auth-manager'

export const UserNav: FC = () => {
    const { t } = useTranslation()
    const { openAuthModal } = useAuthUI()
    const { logout } = useLogout()

    const isTokenExist =
        typeof window !== 'undefined' &&
        window.localStorage.getItem('pylot_token')
    return (
        <div className={cn(s['UserNavBarWrapper'], 'UserNavBarWrapper')}>
            <StoreSwitcher />
            <div className={cn(s.userMenu, s.usernavContent, 'headerUserMenu')}>
                {isTokenExist ? (
                    <DropdownMenu logout={logout} />
                ) : (
                    <Button
                        className={s.avatarButton}
                        variant="link"
                        onClick={() => openAuthModal()}
                        aria-label={t('Menu')}
                    >
                        <User />
                    </Button>
                )}
            </div>
            <div className={cn(s.item, 'cartIconHeader')}>
                <AddToCartIcon />
            </div>
        </div>
    )
}

export default UserNav
